<template>
  <b-navbar
    id="template-header"
    class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
    toggleable="md"
    style="z-index: 1003 !important;"
  >
    <div
      v-if="usuario"
      class="text-center navbar-brand-wrapper d-sm-flex align-items-top justify-content-center"
    >
      <router-link
        v-if="!usuario.info.rol"
        class="navbar-brand brand-logo"
        to="/inicio"
      >
        <!-- <h1 class="logo" style="color: black;">Pixan Cloud</h1> -->
        <template v-if="Object.keys(franquicia).length > 1">
          <img
            v-if="franquicia.foto.url"
            :src="franquicia.foto.url"
            alt="logo"
          />
          <img
            v-else
            src="../../assets/images/logo-pixan-beta.svg"
            alt="logo"
          />
        </template>
        <Cargando :mostrar="true" v-else />
      </router-link>
      <router-link v-else class="navbar-brand brand-logo" to="/panel">
        <!-- <h1 class="logo" style="color: black;">Pixan Cloud</h1> -->
        <template v-if="Object.keys(franquicia).length > 1">
          <img
            v-if="franquicia.foto.url"
            :src="franquicia.foto.url"
            alt="logo"
          />
          <img
            v-else
            src="../../assets/images/logo-pixan-beta.svg"
            alt="logo"
          />
        </template>

        <Cargando :mostrar="true" v-else />
      </router-link>

      <router-link class="navbar-brand brand-logo-mini" to="/">
        <template v-if="Object.keys(franquicia).length > 1">
          <img
            v-if="franquicia.foto.url"
            :src="franquicia.foto.url"
            alt="logo"
          />
          <img
            v-else
            src="../../assets/images/logo-pixan-beta.svg"
            alt="logo"
          />
        </template>
      </router-link>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
      <button
        class="navbar-toggler navbar-toggler align-self-center"
        type="button"
        @click="collapedSidebar()"
      >
        <span class="mdi mdi-menu"></span>
      </button>
      <b-navbar-nav class="navbar-nav-right ml-auto">
        <b-nav-item v-if="checarSiEsPanel"
          >{{ franquicia.nombre }} >> {{ sucursalUsuario }}</b-nav-item
        >
        <!-- Alerta para notificaciones web -->
        <vue-snotify></vue-snotify>
        <!-- Alerta para notificaciones web FIN -->
        <b-nav-item style="color:#ffeb3b;" v-if="!PRODUCCION">
          <!-- <b-button @click="showAlert" variant="info" class="m-1">Show alert with count-down timer</b-button> -->
          MODO: PRUEBAS
        </b-nav-item>

        <!-- Inicio badge notificaciones -->
        <b-nav-item-dropdown
          v-if="checarSiEsPanel"
          right
          class="preview-list"
          id="notif-height"
        >
          <template slot="button-content">
            <div class="nav-link count-indicator">
              <i class="mdi mdi-bell-outline"></i>
              <span class="count bg-success">{{
                notificacionesVista.length
              }}</span>
            </div>
          </template>
          <b-dropdown-item
            class="preview-header"
            @click="$router.push('/notificaciones/todas')"
          >
            <p class="mb-0 font-weight-medium float-left">
              Tienes {{ notificacionesVista.length }} notificaciones
            </p>
            <span class="badge badge-pill badge-primary float-right"
              >Ver todo</span
            >
          </b-dropdown-item>

          <b-dropdown-item
            @click="abrirNotif(notificacion.key)"
            class="preview-item notif-bar"
            v-for="(notificacion, index) in notificacionesVista"
            :key="index"
          >
            <div class="preview-item-content">
              <h6 class="preview-subject font-weight-normal text-dark mb-1">
                {{ notificacion.data.asunto }}
              </h6>
              <p class="font-weight-light small-text mb-0">
                {{ timestampAFecha(notificacion.fecha_envio.seconds) }}
              </p>
            </div>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- Fin badge notificaciones -->
        <b-nav-item-dropdown
          right
          class="preview-list"
          v-if="usuario && checarSiEsPanel"
        >
          <template slot="button-content">
            <div class="d-flex align-items-center">
              <span class="profile-text d-none d-lg-inline">{{
                nombreCompleto
              }}</span>

              <template v-if="fotoURL !== ''">
                <img
                  class="img-xs rounded-circle"
                  :src="fotoURL"
                  alt="Profile image"
                />
              </template>
              <img
                v-else
                class="img-xs rounded-circle profile-img"
                src="../../assets/images/user.jpg"
                alt="Profile image"
              />
            </div>
          </template>
          <template v-if="rolHeader.modulos">
            <b-dropdown-item
              @click="onPerfil"
              v-if="!rolHeader.modulos.usuarios.accesos"
              >Mi perfil</b-dropdown-item
            >
          </template>

          <b-dropdown-item
            v-if="checarSiEsPanel && usuario.rol == 'Admin'"
            @click="modalCuenta = true"
            >Mi cuenta</b-dropdown-item
          >
          <b-dropdown-item @click="onDesconectarse"
            >Cerrar sesión</b-dropdown-item
          >
          <b-dropdown-item v-if="checarSiEsPanel" @click="cambiarFranquicia"
            >Cambiar sucursal</b-dropdown-item
          >
        </b-nav-item-dropdown>
        <!-- Solo admin de panel, por alguna extraña razon si pongo el p se ve -->
        <template v-if="usuario && !checarSiEsPanel">
          <p></p>
          <b-nav-item-dropdown right class="preview-list">
            <template slot="button-content">
              <div class="d-flex align-items-center">
                <span class="profile-text d-none d-lg-inline">{{
                  nombreCompleto
                }}</span>
                <img
                  class="img-xs rounded-circle profile-img"
                  src="../../assets/images/user.jpg"
                  alt="Profile image"
                />
              </div>
            </template>
            <b-dropdown-item @click="onDesconectarse"
              >Cerrar sesión</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </template>

        <b-nav-item>
          <button
            class="navbar-toggler navbar-toggler-right align-self-center"
            type="button"
            @click="collapedMobileSidebar()"
          >
            <span class="mdi mdi-menu"></span>
          </button>
        </b-nav-item>
      </b-navbar-nav>

      <b-modal
        v-if="usuario"
        v-model="modalCuenta"
        hide-footer
        ref="modalCuenta"
        id="modalCuenta"
        size="md"
        title="Mi cuenta"
      >
        <b-row class="card">
          <b-col class="card-body">
            <b-row>
              <b-col md="6">
                <b>{{ getNombrePlan }}</b>
              </b-col>
              <b-col md="6">
                <!-- {{getPrecioPlan}} -->
              </b-col>
            </b-row>
            <hr />
            <div v-if="usuario.estatus_pago.plan != '001'">
              Vigencia al {{ getFechaPlan }}
            </div>
            <div class="mt-5">
              <b-row v-if="usuario.estatus_pago.plan !== 'personalizado'">
                <b-col md="12" v-if="usuario.estatus_pago.plan !== '001'">
                  <form v-if="usuario.estatus_pago.recurrente">
                    <a
                      href="https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=AJ2KA8ALJUAF2&switch_classic=true"
                    >
                      <button class="btn-paypal azul-p">
                        Quitar suscripción
                      </button>
                    </a>
                  </form>
                </b-col>
              </b-row>
              <b-row v-else>
                <b-col md="12">
                  <div v-if="usuario.estatus_pago.plan != 'personalizado'">
                    <form
                      v-if="
                        usuario.estatus_pago.plan == '002' ||
                          usuario.estatus_pago.plan == '002b'
                      "
                      action="https://www.paypal.com/cgi-bin/webscr"
                      method="post"
                      target="_top"
                    >
                      <input type="hidden" name="cmd" value="_s-xclick" />
                      <input
                        type="hidden"
                        name="hosted_button_id"
                        value="XT2HMQDF6AGXN"
                      />
                      <input
                        type="hidden"
                        name="notify_url"
                        value="https://app.pixancloud.com/ws/pagos/planes/procesar_pago.php"
                      />
                      <input
                        type="hidden"
                        name="custom"
                        :value="
                          usuario.id +
                            '*' +
                            usuario.email +
                            '*' +
                            usuario.id_corporativo +
                            '*' +
                            usuario.info.nombre +
                            '*' +
                            usuario.info.apellidos
                        "
                      />
                      <!-- <input type="hidden" name="cancel_return" value="https://app.pixancloud.com/#/pago_cancelado">
                      <input type="hidden" name="return" value="https://app.pixancloud.com/#/pago_completado">-->
                      <input
                        type="hidden"
                        name="cancel_return"
                        value="https://app.pixancloud.com/#/pago_cancelado"
                      />
                      <input
                        type="hidden"
                        name="return"
                        value="https://app.pixancloud.com/#/pago_completado"
                      />

                      <button
                        type="submit"
                        class="btn-paypal"
                        border="0"
                        name="submit"
                        alt="PayPal, la forma más segura y rápida de pagar en línea."
                      >
                        <img src="../../assets/images/pp.png" /> Suscribirse
                      </button>
                      <img
                        class="tarjetas"
                        align="center"
                        src="../../assets/images/cards.jpg"
                      />
                      <img
                        alt=""
                        border="0"
                        src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif"
                        width="1"
                        height="1"
                      />
                    </form>

                    <form
                      v-if="
                        usuario.estatus_pago.plan == '003' ||
                          usuario.estatus_pago.plan == '003b'
                      "
                      action="https://www.paypal.com/cgi-bin/webscr"
                      method="post"
                      target="_top"
                    >
                      <input type="hidden" name="cmd" value="_s-xclick" />
                      <input
                        type="hidden"
                        name="hosted_button_id"
                        value="KT7SL436W27KN"
                      />
                      <input
                        type="hidden"
                        name="notify_url"
                        value="https://app.pixancloud.com/ws/pagos/planes/procesar_pago.php"
                      />
                      <input
                        type="hidden"
                        name="custom"
                        :value="
                          usuario.id +
                            '*' +
                            usuario.email +
                            '*' +
                            usuario.id_corporativo +
                            '*' +
                            usuario.info.nombre +
                            '*' +
                            usuario.info.apellidos
                        "
                      />
                      <!-- <input type="hidden" name="cancel_return" value="https://app.pixancloud.com/#/pago_cancelado">
                      <input type="hidden" name="return" value="https://app.pixancloud.com/#/pago_completado">-->
                      <input
                        type="hidden"
                        name="cancel_return"
                        value="https://app.pixancloud.com/#/pago_cancelado"
                      />
                      <input
                        type="hidden"
                        name="return"
                        value="https://app.pixancloud.com/#/pago_completado"
                      />

                      <button
                        type="submit"
                        class="btn-paypal"
                        border="0"
                        name="submit"
                        alt="PayPal, la forma más segura y rápida de pagar en línea."
                      >
                        <img src="../../assets/images/pp.png" /> Suscribirse
                      </button>
                      <img
                        class="tarjetas"
                        align="center"
                        src="../../assets/images/cards.jpg"
                      />
                      <img
                        alt=""
                        border="0"
                        src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif"
                        width="1"
                        height="1"
                      />
                    </form>
                  </div>
                </b-col>
              </b-row>
              <br />
              <b-button
                v-if="usuario.estatus_pago.plan == '001'"
                variant="success"
                class="btn-fw btn-res pointer"
                @click="$router.push('/suscripcion')"
                >Comprar plan</b-button
              >
            </div>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        v-model="seguroR"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        hide-footer
        ref="seguroR"
        id="seguroR"
        size="md"
        title="¿Esta seguro que desea desactivar la renovación automática?"
      >
        <footer
          id="modallg___BV_modal_footer_"
          class="modal-footer footer-sin-padding"
        >
          <b-col class="col-12 text-center">
            <b-button
              @click="
                $refs.seguroR.hide();
                $refs.modalCuenta.show();
                toggleB = true;
              "
              variant="danger"
              class="btn-fw btn-res"
              >Cancelar</b-button
            >
            <!-- <b-btn @click="" variant="success" class="btn-fw btn-res">Desactivar</b-btn> -->
          </b-col>
        </footer>
      </b-modal>

      <ModalCargando v-if="modalCargando" />

      <b-modal
        modal-header-close="No"
        v-model="modalCargandoCaracteristicas"
        hide-footer
        ref="modalCargandoCaracteristicas"
        id="modalCuenta"
        size="md"
        title=""
      >
        <b-row class="card">
          <b-col class="card-body">
            <b-row>
              Gracias por su pago.<br />
              Su pago se ha completado y le hemos enviado un recibo de su compra
              por correo electrónico.<br />
              Para ver los detalles de la transacción, inicie sesión en su
              cuenta PayPal.<br /><br />
              Espere por favor, cargando caracteristicas, puede tardar hasta 10
              min.<br /><br />
              Sí tarda más comunicarse con soporte tectnico 9238322324.
            </b-row>
            <hr />
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </b-navbar>
</template>

<script>
var baseUrl = window.location.origin;
// eslint-disable-next-line
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import { fechasMixins } from "@/mixins/fechasMixins";
import Vue from "vue";
import moment from "moment";
import { PRODUCCION } from "@/constantes/environment";
import Snotify, { SnotifyPosition, SnotifyStyle } from "vue-snotify";
const optionsSnoti = {
  toast: {
    position: SnotifyPosition.rightTop,
    type: SnotifyStyle.success
  }
};
Vue.use(Snotify, optionsSnoti);

export default {
  mixins: [fechasMixins],
  name: "app-header",
  data() {
    return {
      flagCargaCorporativo: 1,
      dismissSecs: 10,
      dismissCountDown: 0,
      textoNTF: "textoNTF textoNTF textoNTF",
      modalCuenta: false,
      modalRenovacion: false,
      modalCargandoCaracteristicas: false,
      timerChecarBase: "",
      seguroR: false,
      toggleB: true,
      modalCargando: false,
      PRODUCCION
    };
  },
  components: {
    Cargando: () => import("@/componentes/cargando"),
    ModalCargando: () => import("@/componentes/cargando/modalCargando")
  },
  computed: {
    ...mapGetters([
      "nombreCompleto",
      "usuario",
      "franquicia",
      "indiceSucursales",
      "lista_notificaciones",
      "corporativoinfo",
      "rolHeader"
    ]),
    notificacionesVista() {
      var p = [];
      console.log(this.lista_notificaciones);
      if (this.lista_notificaciones == undefined) {
        return [];
      }
      for (var key in this.lista_notificaciones.inmediatas) {
        var item = this.lista_notificaciones.inmediatas[key];
        item.key = key;

        if (item.leida == false) {
          p.push(item);
        }
      }

      /*p.sort(function(a,b){
        return new Date(b.fecha_envio) - new Date(a.fecha_envio);
      });*/

      return p.reverse();
    },
    fotoURL() {
      if (!this.usuario) {
        return "";
      }
      if (this.usuario.foto) {
        return this.usuario.foto;
      }
      return "";
    },
    sucursalUsuario() {
      if (!this.usuario) {
        this.modalCargando = true;
        return "";
      }
      if (this.usuario.sucursal_actual) {
        let sucursal = this.indiceSucursales[this.usuario.sucursal_actual];

        if (sucursal === undefined) {
          return "";
        } else {
          this.modalCargando = false;
        }

        return sucursal.nombre;
      }
      return "Sin Sucursal asignada";
    },
    getNombrePlan() {
      let resultado = "Personalizado";
      if (this.usuario) {
        const plan = this.usuario.estatus_pago.plan;
        if (plan == "001") {
          resultado = "GRATIS";
        }
        if (plan == "002") {
          resultado = "Semestral: 6 +1 meses";
        }
        if (plan == "003") {
          resultado = "Anual: 12 +1 meses";
        }
        if (plan == "002b") {
          resultado = "Semestral: 6 meses";
        }
        if (plan == "003b") {
          resultado = "Anual: 12 meses";
        }
        if (plan == "plan1mes") {
          resultado = "1 mes";
        }

        if (plan == "estandar1mes") {
          return "Estandar 1 mes";
        }
        if (plan == "estandar3mes") {
          return "Estandar 3 meses";
        }
        if (plan == "estandar6mes") {
          return "Estandar 6 meses";
        }
        if (plan == "estandar12mes") {
          return "Estandar 12 meses";
        }

        if (plan == "plus1mes") {
          return "Plus 1 mes";
        }
        if (plan == "plus3mes") {
          return "Plus 3 meses";
        }
        if (plan == "plus6mes") {
          return "Plus 6 meses";
        }
        if (plan == "plus12mes") {
          return "Plus 12 meses";
        }

        if (plan == "ultra1mes") {
          return "Ultra 1 mes";
        }
        if (plan == "ultra3mes") {
          return "Ultra 3 meses";
        }
        if (plan == "ultra6mes") {
          return "Ultra 6 meses";
        }
        if (plan == "ultra12mes") {
          return "Ultra 12 meses";
        }
      }

      return resultado;
    },
    getPrecioPlan() {
      let resultado = "Personalizado";
      if (this.usuario) {
        if (this.usuario.estatus_pago.plan == "001") {
          resultado = "Gratuito";
        }
        if (
          this.usuario.estatus_pago.plan == "002" ||
          this.usuario.estatus_pago.plan == "002b"
        ) {
          resultado = "$3,900 MXN";
        }
        if (
          this.usuario.estatus_pago.plan == "003" ||
          this.usuario.estatus_pago.plan == "003b"
        ) {
          resultado = "$7,200 MXN";
        }
      }

      return resultado;
    },
    getFechaPlan() {
      if (this.usuario) {
        if (this.usuario.estatus_pago.plan == "001") {
          return "No expira";
        }

        var localLocale = "";
        if (this.usuario.estatus_pago.fecha_pago) {
          if (this.usuario.estatus_pago.fecha_pago.seconds) {
            var currentDate = moment.unix(
              this.usuario.estatus_pago.fecha_pago.seconds
            );
            localLocale = moment(currentDate);
          } else {
            localLocale = moment(this.usuario.estatus_pago.fecha_pago);
          }
        } else {
          return "Dato no disponible";
        }

        moment.locale("es");
        localLocale.locale(false);
        return localLocale.format("LL");
      }
    },
    checarSiEsPanel() {
      if (
        this.$route.path == "/panel" ||
        this.$route.path == "/empleados" ||
        this.$route.path == "/empleado" ||
        this.$route.path == "/panel_sucursales" ||
        this.$route.path == "/panel_roles" ||
        this.$route.name == "panel_rol" ||
        this.$route.name == "panel_rolnuevo" ||
        this.$route.path == "/panel_rol" ||
        this.$route.name == "cliente_editar" ||
        this.$route.name == "cliente"
      ) {
        return false;
      }
      return true;
    }
  }, //fin metodos
  created() {
    if (this.usuario && this.franquicia) {
      if (this.usuario.tipo == "empleado") {
        this.modalCargando = false;
        this.$router.push("/panel");
      } else {
        this.cargaNotificaciones();
        this.cargaIndiceSucursales(this.usuario.id_franquicia);
        this.cargaInfoCorporativoGet(this.usuario.id_corporativo);

        // Verificar si no tiene sucursal asignada
        this.$nextTick(() => {
          if (
            this.sucursalUsuario === "Sin Sucursal asignada" &&
            this.checarSiEsPanel
          ) {
            this.$swal
              .fire({
                icon: "warning",
                type: "warning",
                title: "¡Atención!",
                text: "Debes seleccionar una sucursal y almacén para continuar",
                confirmButtonText: "Seleccionar sucursal",
                allowOutsideClick: false,
                allowEscapeKey: false
              })
              .then(result => {
                console.log("🚀 ~ result:", result);
                if (result) {
                  this.$router.push("/franquicia-cambio");
                }
              });
          }
        });

        if (this.$route.name == "pago_completado") {
          this.modalRenovacion = false;
          this.modalCargandoCaracteristicas = true;
        }
      }
    }

    // Recibir notificaciones Web
    this.$messaging.onMessage(payload => {
      console.log("Message received. ", payload);
      console.log("notificación: ");

      console.log(payload.notification);
      this.showSnotify(payload.notification);
    });
  },
  watch: {
    usuario: function(val) {
      if (this.usuario && this.corporativoinfo.id) {
        if (this.usuario.tipo == "empleado") {
          this.modalCargando = false;
          this.$router.push("/panel");
        } else {
          this.cargaNotificaciones();
          this.cargaIndiceSucursales(this.usuario.id_franquicia);
          this.cargaInfoCorporativoGet(this.usuario.id_corporativo);
          console.log("TCL: WATCH CORPORATIVO", this.corporativoinfo);

          if (this.usuario.estatus_pago.pruebas) {
            // SI ESTA MODO PRUEBAS SE PARA EL CHECADOR DB
            clearInterval(this.timerChecarBase);
          }

          if (this.$route.name == "pago_completado") {
            this.modalRenovacion = false;
            this.modalCargandoCaracteristicas = true;
          }
        }
      }
    },
    corporativoinfo: function(val) {
      console.log("Se modifico el corporativo");
      if (this.usuario) {
        if (this.usuario.tipo == "empleado") {
          this.modalCargando = false;
          this.$router.push("/panel");
        } else {
          if (this.flagCargaCorporativo == 1) {
            this.flagCargaCorporativo++;
          }
        }
        this.modalCargando = false;
      }
    },
    franquicia: function(val) {
      //this.cargaInfoCorporativoGet().then(corp => this.corporativoinfo_inicial=corp);
      if (this.usuario.tipo == "empleado") {
        this.modalCargando = false;
        this.$router.push("/panel");
      } else {
        this.cargaNotificaciones();
        this.cargaIndiceSucursales(this.usuario.id_franquicia);
        this.cargaInfoCorporativoGet(this.usuario.id_corporativo);
      }
    },
    sucursalUsuario: function(val) {
      if (val === "Sin Sucursal asignada" && this.checarSiEsPanel) {
        this.$swal
          .fire({
            icon: "warning",
            title: "¡Atención!",
            type: "warning",
            text: "Debes seleccionar una sucursal y almacén para continuar",
            confirmButtonText: "Seleccionar sucursal",
            allowOutsideClick: false,
            allowEscapeKey: false
          })
          .then(result => {
            console.log("🚀 ~ result:", result);
            if (result) {
              this.$router.push("/franquicia-cambio");
            }
          });
      }
    }
  },
  methods: {
    ...mapActions([
      "desconectarse",
      "cargaIndiceSucursales",
      "cargaInfoCorporativoGet",
      "cargaNotificaciones",
      "actualizarUsuario",
      "actualizaCorporativo"
    ]),
    onDesconectarse() {
      //this.modalCargando = true;
      localStorage.flagLogin = 1;
      this.desconectarse().then(result => {
        //this.modalCargando = true;
        //window.location.href = baseUrl;
      });
    },
    onPerfil() {
      this.$router.push({ name: "perfil", params: { id: this.usuario.id } });
    },
    renovacion() {
      if (this.toggleB == false) {
        this.modalCuenta = false;
        this.seguroR = true;
      }
    },
    collapedSidebar: function() {
      $("body").toggleClass("sidebar-icon-only");
    },
    collapedMobileSidebar: function() {
      $("#sidebar").toggleClass("active");
    },
    cambiarFranquicia() {
      this.$router.push("/franquicia-cambio");
    },
    abrirNotif(index) {
      this.$router.push({
        name: "notificaciones",
        params: { id: index }
      });
    },

    // Alertas Notificaciones
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    accionNTF(link) {
      console.log(link);
      window.location.href = link;
    },
    showSnotify(notificacion) {
      var title = "";
      if (notificacion.title.length > 35) {
        title = notificacion.title.substring(0, 35) + "...";
      } else {
        title = notificacion.title;
      }
      var body = "";
      if (notificacion.body.length > 75) {
        body = notificacion.body.substring(0, 80) + "...";
      } else {
        body = notificacion.body;
      }

      this.$snotify.html(
        `
          <div class="snotifyToast__title">
          <h4>` +
          title +
          `</h4>
          </div>
          <div class="snotifyToast__body">
            <p>` +
          body +
          `</p>
          </div>`,
        {
          body: null,
          config: {
            position: SnotifyPosition.rightTop,
            type: SnotifyStyle.info
          },
          timeout: 5000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [
            {
              text: "Ver mas...",
              action: () => {
                return this.accionNTF(notificacion.click_action);
              },
              bold: true
            }
          ]
        }
      );
    }
  }
};
</script>
<style scoped lang="scss">
.loader-demo-box {
  border: 0px solid #f2f2f2 !important;
}

.btn-paypal {
  background: #2270ba;
  /* margin-top: -1px; */
  cursor: pointer;
  width: 100%;
  color: #fff;
  font-weight: 700;
  border: 0;
  padding: 0px;
  border-radius: 100px;

  /* height: 63px !important; */
  img {
    height: 100%;
    width: auto;
  }
}

img.tarjetas {
  max-width: 120px;
  margin: 5px auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue